import React, { useState } from "react";
import { capitalizeFirstLetter } from "../../utils/common_lib";
import moment from "moment";
import { getLoggedinUser } from "../../userStore";
import AppointmentSurvey from "./AppointmentSurvey";

const List = ({ data = [], isLoadingList = false,showAppointmentTime }) => {
  const user = getLoggedinUser();
  return (
    <div className="mt-4">
      {data?.map((appointment) => (
        <>
          <ListCard
            key={appointment?.id}
            title={appointment?.reason || appointment?.reason_title}
            location={appointment?.location_name}
            Specialty={appointment?.specialty}
            date={appointment?.date || appointment?.start_time}
            status={appointment?.status}
            message={appointment?.message}
            username={appointment?.created_by_name}
            withName={
              appointment?.providers?.[0]?.id != 0
                ? appointment?.providers?.[0]?.name
                : null
            }
            statusColor={appointment?.appointment_status_color}
            appointment_status_text_color={
              appointment?.appointment_status_text_color
            }
            timeString={
              appointment?.apt_start_time
                ? moment(appointment?.apt_start_time, "HH:mm:ss").format(
                    "hh:mm A"
                  ) +
                  " - " +
                  moment(appointment?.apt_end_time, "HH:mm:ss").format(
                    "hh:mm A"
                  ) +
                  " (" +
                  appointment?.duration +
                  " mins)"
                : ""
            }
            practice_id={user?.practice_id}
            appointment={appointment}
            appointment_id={appointment?.id}
            created_at={appointment?.created_at}
            created_by_name={appointment?.created_by_name}
            showAppointmentTime={showAppointmentTime}
          />
        </>
      ))}
      {data?.length === 0 && isLoadingList == false && (
        <div class="bg-white shadow-md border-2 rounded overflow-hidden max-w-sm">
          <div class=" items-center px-16 py-4 text-center">
            No Appointments Found
          </div>
        </div>
      )}
      {isLoadingList && (
        <div class="bg-white animate-pulse shadow-md border-2 rounded overflow-hidden max-w-sm">
          <div class=" items-center px-16 py-4 text-center">Loading...</div>
        </div>
      )}
    </div>
  );
};

const returnColor = (status) => {
  switch (status) {
    case "Pending":
      return "bg-orange-400";
    case "Completed":
      return "bg-yellow-500";
    case "Scheduled":
      return "bg-blue-500";
    case "Cancelled":
      return "bg-red-500";
    default:
      return "bg-blue-500";
  }
};

const ListCard = ({
  title = "",
  location = "",
  Specialty = "",
  date = new Date(),
  status = "",
  message = "",
  username = "",
  withName = "",
  timeString = "",
  statusColor = "",
  appointment_status_text_color = "",
  practice_id = "",
  appointment_id = "",
  created_at = "",
  created_by_name = "",
  showAppointmentTime
}) => {
  const [showSurvey, setShowSurvey] = useState(false);

  return (
    <>
      {showSurvey && (
        <AppointmentSurvey
          setShowSurvey={setShowSurvey}
          showSurvey={showSurvey}
          withName={withName}
          appointment_id={appointment_id}
          date={date}
          timeString={timeString}
          location={location}
        />
      )}
      <div className="flex justify-between">
        <div class={`rounded-2xl p-4  w-[90%]`}>
          <div className="flex">
            <div class="bg-white shadow-md rounded overflow-hidden max-w-56 max-h-36 min-h-36 min-w-56">
              <div class=" items-center px-6 py-2 bg-green-700">
                <div class=" text-white">
                  <div class="text-lg font-bold uppercase leading-7">
                    {date ? moment(date).format("MMM") : ""}
                  </div>
                  <div class="text-4xl leading-7">
                    {moment(date).format("DD")}
                  </div>
                  <div class="text-lg leading-7 ">
                    {moment(date).format("yyyy")}
                  </div>
                </div>
              </div>
              <div
                class={`text-center text-black text-lg py-2 px-6 }`}
                style={statusColor && { backgroundColor: statusColor }}>
                <span
                  style={
                    appointment_status_text_color && {
                      color: appointment_status_text_color,
                    }
                  }>
                  {status ? status : "No Status"}
                </span>
              </div>
            </div>
            <div className="ml-8 w-full">
              <h1 class=" font-bold text-start   text-2xl">
                {capitalizeFirstLetter(title)}
              </h1>

              <dl class=" space-y-1 text-sm mt-2 text-gray-600">
                {(timeString && showAppointmentTime) ? (
                  <div className="text-start font-medium">
                    {" "}
                    {timeString && <span>{timeString}</span>}
                  </div>
                ):''}
                <h5 className=" text-start  ">
                  {withName && withName != "Unassigned" && (
                    <span className="font-medium">
                      <span className="font-bold text-lg">With: </span>{" "}
                      {withName}
                    </span>
                  )}
                </h5>
                <h5 className=" text-start   ">
                  <span className="font-medium ">
                    <span className="font-bold text-lg">At: </span> {location}
                  </span>
                </h5>
                <h5 class=" text-start   ">
                  {Specialty && (
                    <span className="font-medium">
                      <span className="font-bold text-lg">Specialty: </span>{" "}
                      {Specialty}
                    </span>
                  )}
                </h5>
                <h6 class=" text-start   text-gray ">
                  {created_by_name}: {moment(created_at).format("MM/DD/YYYY")}
                </h6>
              </dl>
            </div>
          </div>
          {status == "Pending" && (
            <p class="text-start text-red-700 leading-7 mt-2 ">
              Thank you for submitting your appointment request. 
              Your appointment is pending for approval. It is not confirmed until a staff member reaches out to you
            </p>
          )}
        </div>
        {practice_id == 165 &&
          (status == "Completed" || status == "Checked Out") && (
            <div className="m-2">
              <span
                className="text-blue-700 underline cursor-pointer"
                onClick={() => setShowSurvey(true)}>
                Survey
              </span>
            </div>
          )}
      </div>
      <div class="flex-grow border-t border-gray-400 mt-4 m-4 "></div>
    </>
  );
};

export default List;
